import { Route, Routes } from "react-router-dom";
import { PermissionRoute } from "../../../routes/PermissionRoute";
import HomePage from "../pages/Home";
import CompanyPage from "../pages/Company";
import IntegrationsPage from "../pages/Integrations";
import UsersPage from "../pages/Users";
import PreferencesPage from "../pages/Preferences";
import RolesPage from "../pages/Roles";
import CreateUserPage from "../pages/Users/create";
import BillingPage from "../pages/Billing";
import SecurityPage from "../pages/Security";
import AuditLogsPage from "../pages/Logs";
import SubscribePage from "../pages/Billing/subscribe";
import PayPage from "../pages/Billing/pay";
import BranchesPage from "../pages/Branches";
import CreateBranchPage from "../pages/Branches/create";

export default function SettingsRoutes() {
  return(
    <Routes>
      <Route path="home" element={<HomePage />} />

      <Route element={<PermissionRoute permission="settings.company.view" />}>
        <Route path="company" element={<CompanyPage />} />
      </Route>

      <Route path="users" element={<PermissionRoute permission="settings.users.view" />}>
        <Route path="" element={<UsersPage />} />
        <Route path="create" element={<CreateUserPage />} />
        <Route path="edit/:id" element={<CreateUserPage />} />
      </Route>

      <Route element={<PermissionRoute permission="settings.roles.view" />}>
        <Route path="roles" element={<RolesPage />} />
      </Route>

      <Route element={<PermissionRoute permission="settings.branches.view" />}>
        <Route path="branches">
          <Route path="" element={<BranchesPage />} />
          <Route path="create" element={<CreateBranchPage />} />
          <Route path="edit/:id" element={<CreateBranchPage />} />
        </Route>
      </Route>

      <Route element={<PermissionRoute permission="settings.preferences.view" />}>
        <Route path="preferences" element={<PreferencesPage />} />
      </Route>

      <Route path="integrations" element={<IntegrationsPage />} />

      <Route element={<PermissionRoute permission="settings.security.view" />}>
        <Route path="security" element={<SecurityPage />} />
        <Route path="audit-logs" element={<AuditLogsPage />} />
      </Route>

      <Route element={<PermissionRoute permission="settings.billing.view" />}>
        <Route path="billing" element={<BillingPage />} />
        <Route path="billing/subscribe" element={<SubscribePage />} />
        <Route path="billing/pay" element={<PayPage />} />
      </Route>
    </Routes>
  );
}